module.exports = __webpack_public_path__ + "5408e0074eb0f7b25fedf1a9d37538fa.png";